/**
 * Layout paramètres : contenu limité à 650px (onglets = sous-barre dans NavbarSite).
 */
const SettingsLayout = ({ children }) => (
  <div className="flex w-full max-w-[650px] min-h-0 flex-1 flex-col gap-4 overflow-hidden px-[20px] pt-2 pb-6">
    {children}
  </div>
);

export default SettingsLayout;
